class WebEncrypt {
    static encryptSubtleCrypto = async (text: string, key: JsonWebKey) => {
        const importedKey = await window.crypto.subtle.importKey(
            "jwk",
            key,
            {
                name: "RSA-OAEP",
                modulusLength: 4096,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: "SHA-256"
            } as AlgorithmIdentifier,
            true,
            ['encrypt']
        )
        const encoded = new TextEncoder().encode(text);
        const cipherText = await window.crypto.subtle.encrypt(
            { name: "RSA-OAEP" },
            importedKey,
            encoded
        );
        var arr = new Uint8Array(cipherText);
        return String.fromCharCode.apply(String, Array.from(arr));
    }

    static decryptSubtleCrypto = async (text: string, key: JsonWebKey) => {
        const importedKey = await window.crypto.subtle.importKey(
            "jwk",
            key,
            {
                name: "RSA-OAEP",
                modulusLength: 4096,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: "SHA-256"
            } as AlgorithmIdentifier,
            true,
            ['decrypt']
        )

        var arr = new Uint8Array(text.length);
        for (var i = text.length; i--;) {
            arr[i] = text.charCodeAt(i);
        }

        const decrypt = await window.crypto.subtle.decrypt(
            { name: "RSA-OAEP" },
            importedKey,
            arr.buffer
        )

        return JSON.parse(new TextDecoder().decode(decrypt));
    }

    static generateKeyPairSubtleCryptoWithJWK = async () => {
        const key_pair = await window.crypto.subtle.generateKey(
            {
                name: "RSA-OAEP",
                modulusLength: 4096,
                publicExponent: new Uint8Array([1, 0, 1]),
                hash: "SHA-256",
            },
            true,
            ["encrypt", "decrypt"],
        )
        const privateKeyJWK = await window.crypto.subtle.exportKey("jwk", key_pair.privateKey);
        const publicKeyJWK = await window.crypto.subtle.exportKey("jwk", key_pair.publicKey);
        return { publicKey: publicKeyJWK, privateKey: privateKeyJWK };
    }
}

export default WebEncrypt;